import { Injectable, inject } from '@angular/core';
import { TableFieldModel } from '@module-definition/table-field/common/table-field.models';
import { HttpService } from '@shared/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class FieldDefinitionService {
  private http = inject(HttpService);

  getTableFields(entityInstanceId: number, tableFieldId: number) {
    const params = this.http.buildHttpParams({ entityInstanceId, id: tableFieldId });

    return this.http.get<TableFieldModel[]>(`_api/FieldDefinition/TableFields`, {
      httpOptions: { params },
      useLoader: false,
    });
  }
}
